import { createSlice } from "@reduxjs/toolkit"
import { stateEnum } from "../constants/enum.js"

const { roughAllotment } = stateEnum

const initialState = {
  detailParams: {},
  isNewEntry: false,
}


const roughAllotmentEntrySlice = createSlice({
  name: roughAllotment,
  initialState,
  reducers: {

    setNewEntryMode: (state, action) => {
      state.isNewEntry = action.payload
    },
    setDetailParams: (state, action) => {
      state.detailParams = action.payload
    },
    resetDetailParams: (state) => {
      state.detailParams = {}
      state.isNewEntry = true

    },
  },

})

export const { setDetailParams, resetDetailParams, setNewEntryMode,  } = roughAllotmentEntrySlice.actions
export default roughAllotmentEntrySlice.reducer
